// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/assets/img/loginImage.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.buttonAndText {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.forgotPassword {
  cursor: pointer;
  /* color: #14bad5; */
}

.buttonAndText .forgotPassword:hover {
  color: var(--text-color);
}

.showErrorMessage {
  display: block;
}

.hideErrorMessage {
  display: none;
}

.user_error_popup {
  position: absolute;
  width: 91%;
  top: 200px;
  right: 20px;
}

.user_error_popup span {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  font-size: 12px;
  padding: 3px;
  color: red;
}

.showLogin {
  display: block;
}
.hideLogin {
  display: none !important;
}

.non_desktop_mode {
  text-align: center;
}

.non_desktop_mode:hover {
  color: red;
}
.leftImage img {
  width: 100%;
}

@media (max-width: 1199px) {
  .showLogin {
    display: none !important;
  }

  .hideLogin {
    display: block !important;
  }
}

.buttonAndText .login_loader {
  height: 60px;
  position: absolute;
  top: -10px;
  left: 15%;
}

.signinContainer {
  display: flex;
  height: 100vh;
}

.signinContainer .image-holder {
  width: 50%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}

.signinContainer .form-container {
  display: flex;
  width: 100%;
  margin: 0 auto;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
}

.signinContainer .form {
  width: 50%;
  background-color: #ffffff;
  padding: 0px 60px;
  display: flex;
  align-items: center;
}
.showLogin .formWrapper,
.forgotPassword .formWrapper {
  width: 80%;
  margin: auto;
}
.showLogin .signinContainer .card-header.card-header-border-bottom,
.forgotPassword .signinContainer .card-header.card-header-border-bottom {
  display: block;
  border-bottom: 1px solid var(--border-color);
  margin: 0 20px;
  padding: 10px 0;
}
.showLogin .signinContainer .card-header.card-header-border-bottom h2,
.forgotPassword .signinContainer .card-header.card-header-border-bottom h2 {
  font-weight: 600;
}
.showLogin .brandTitle,
.forgotPassword .brandTitle {
  position: initial;
  font-size: 32px;
  font-weight: 600;
  text-transform: initial;
  letter-spacing: 2px;
  color: #000;
  text-align: right;
}
.showLogin .ec-brand span,
.forgotPassword .ec-brand span {
  border: 0;
  transition: none;
  justify-content: flex-end;
  margin-left: auto;
  margin-right: 20px;
  margin-bottom: 30px;
}
.showLogin .ec-brand span .brandTitle img,
.forgotPassword .ec-brand span .brandTitle img {
  max-width: 100%;
}

@media (max-width: 991px) {
  .signinContainer .form {
    padding: 40px;
  }
}

.no-reveal::-ms-reveal {
  display: none;
}

.password-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.input-container {
  position: relative;
  margin-bottom: 20px;
}

.input-container input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.eye_icon svg{
  height: 15px;
}

.hide_eye_icon svg {
  height: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Global/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mDAA6D;EAC7D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,UAAU;EACV,YAAY;AACd;AACA;;EAEE,cAAc;EACd,4CAA4C;EAC5C,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;;EAEE,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".loginContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n}\n\n.buttonAndText {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n}\n\n.forgotPassword {\n  cursor: pointer;\n  /* color: #14bad5; */\n}\n\n.buttonAndText .forgotPassword:hover {\n  color: var(--text-color);\n}\n\n.showErrorMessage {\n  display: block;\n}\n\n.hideErrorMessage {\n  display: none;\n}\n\n.user_error_popup {\n  position: absolute;\n  width: 91%;\n  top: 200px;\n  right: 20px;\n}\n\n.user_error_popup span {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: start;\n  font-size: 12px;\n  padding: 3px;\n  color: red;\n}\n\n.showLogin {\n  display: block;\n}\n.hideLogin {\n  display: none !important;\n}\n\n.non_desktop_mode {\n  text-align: center;\n}\n\n.non_desktop_mode:hover {\n  color: red;\n}\n.leftImage img {\n  width: 100%;\n}\n\n@media (max-width: 1199px) {\n  .showLogin {\n    display: none !important;\n  }\n\n  .hideLogin {\n    display: block !important;\n  }\n}\n\n.buttonAndText .login_loader {\n  height: 60px;\n  position: absolute;\n  top: -10px;\n  left: 15%;\n}\n\n.signinContainer {\n  display: flex;\n  height: 100vh;\n}\n\n.signinContainer .image-holder {\n  width: 50%;\n  background: url(../../../../public/assets/img/loginImage.jpg);\n  background-size: cover;\n}\n\n.signinContainer .form-container {\n  display: flex;\n  width: 100%;\n  margin: 0 auto;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);\n}\n\n.signinContainer .form {\n  width: 50%;\n  background-color: #ffffff;\n  padding: 0px 60px;\n  display: flex;\n  align-items: center;\n}\n.showLogin .formWrapper,\n.forgotPassword .formWrapper {\n  width: 80%;\n  margin: auto;\n}\n.showLogin .signinContainer .card-header.card-header-border-bottom,\n.forgotPassword .signinContainer .card-header.card-header-border-bottom {\n  display: block;\n  border-bottom: 1px solid var(--border-color);\n  margin: 0 20px;\n  padding: 10px 0;\n}\n.showLogin .signinContainer .card-header.card-header-border-bottom h2,\n.forgotPassword .signinContainer .card-header.card-header-border-bottom h2 {\n  font-weight: 600;\n}\n.showLogin .brandTitle,\n.forgotPassword .brandTitle {\n  position: initial;\n  font-size: 32px;\n  font-weight: 600;\n  text-transform: initial;\n  letter-spacing: 2px;\n  color: #000;\n  text-align: right;\n}\n.showLogin .ec-brand span,\n.forgotPassword .ec-brand span {\n  border: 0;\n  transition: none;\n  justify-content: flex-end;\n  margin-left: auto;\n  margin-right: 20px;\n  margin-bottom: 30px;\n}\n.showLogin .ec-brand span .brandTitle img,\n.forgotPassword .ec-brand span .brandTitle img {\n  max-width: 100%;\n}\n\n@media (max-width: 991px) {\n  .signinContainer .form {\n    padding: 40px;\n  }\n}\n\n.no-reveal::-ms-reveal {\n  display: none;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.input-container {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.input-container input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.eye_icon svg{\n  height: 15px;\n}\n\n.hide_eye_icon svg {\n  height: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
